import { ElementRef, Inject, Injectable, OnDestroy, PLATFORM_ID, Renderer2, TransferState, makeStateKey } from '@angular/core';
import { MktDynamicOfferService } from '../../core/services/mkt-dynamic-offer.service';
import { Subscription } from 'rxjs';
import { MktContentService } from 'src/app/core/services/mkt-content.service';
import { MktContentStorageService } from 'src/app/core/services/mkt-content-storage.service';
import { DOCUMENT, isPlatformBrowser } from '@angular/common';
import { ElementEvents, UpdateElement } from './footnote.service';
import { InactivityService } from './inactivity.services';
import { CookieService } from '@citi-gcg-173875/citi-utils';
import { MktAEMService } from 'src/app/core/services/mkt-aem.service';
import { BreakpointObserver } from '@angular/cdk/layout';

const CONSTANTS = {
  ADDITIONAL_INFO_BUNDLE: 'Additional_Info_Pages',
  BANNER_BUNDLE: 'Banner',
  BRANDING_BUNDLE: 'Branding',
  DIGITAL_WALLET_BUNDLE: 'Digital_Wallet',
  HOME_BUNDLE: 'Home_Page',
  MICROSITE_BUNDLE: 'Microsites',
  MULTI_PRODUCT_BUNDLE: 'Multi_Product_Page',
  PRODUCT_DETAIL_BUNDLE: 'Product_Detail_Pages'
};
const PRICE_DETAILS_KEY = makeStateKey<any>('priceDetails');
const CARDS_WITH_RATINGS = makeStateKey("cardsWithRatings");
const PRIORITY={
  DEFER: 'defer',
  ASYNC: 'async'
}
const MBOL_PRE_LOGIN = 'mbol_cards_prelogin_acq';
const MBOL_POST_LOGIN = 'mbol_cards_cs_acq';
@Injectable({ providedIn: 'root' })
export class OfferUtilService implements OnDestroy {
  private dynamicOfferSub: Subscription = new Subscription();
  private isBrowser: boolean;
  private eventListeners: any = [];
  public version = 'v1';
  public isAEMPDPPage = false;
  public isMobile;
  public flowParams = {};
  constructor(
    private mktDynamicOfferService: MktDynamicOfferService,
    private _mktContentService: MktContentService,
    private _mktContentStorageService: MktContentStorageService,
    private _inactivityService: InactivityService,
    private _transferState: TransferState,
    private _cookieService: CookieService,
    private _mktAEMService:MktAEMService,
    private breakpointObserver: BreakpointObserver,
    @Inject(DOCUMENT) private _document: Document,
    @Inject(PLATFORM_ID) private platform_id) {
    this.isBrowser = isPlatformBrowser(this.platform_id);
    this.checkMobileorDesktop();
  }

  ngOnDestroy() {
    this.dynamicOfferSub.unsubscribe();
  }

  public isDefaultOffer = (offerName) => (!!offerName && offerName === "CMSDefaultOffer");

  getAllDynamicOffer({ pageId, affinityId, category, screenId, intc, isBannerCallRequired = false, soc = '', rafid = '', pdpPageLink = 'PDP_URL_PID', rewardProgramType = '' }, callback) {
    this._inactivityService.activityHandler(); // RESET the timer
    const cardPriceRequest = this.mktDynamicOfferService.getAllDynamicOffer(pageId, '', affinityId, category, isBannerCallRequired, rewardProgramType);
    this.dynamicOfferSub.add(cardPriceRequest.subscribe({
      next: dynamicOffer => {
        if (dynamicOffer === null) return;
        let pricingDetails = [];
        dynamicOffer['pricingDetails'].map(priceDetail => {
          pricingDetails.push({
            ...this.handleDymamicUrls(priceDetail, pdpPageLink, { screenId, intc, pageId, soc, rafid, afc: affinityId, category }),
          });
        });
        this._transferState.set(PRICE_DETAILS_KEY, pricingDetails);
        // console.log(">>> Pricing loaded  Successfully !!!");
        this.mktDynamicOfferService.setPriceDetails(pricingDetails);
        return callback('Success');
      },
      error: _ => {
        const priceDetail = {};
        const dynamicOffer = this.setDynamicUrls({ priceDetail, pid: '', screenId, intc, pageId, soc, rafid, afc: affinityId, category });
        this.mktDynamicOfferService.setPriceDetails(dynamicOffer);
        console.log(">>> Pricing service  Failed !!!")
        return callback('Failed');
      }
    }));
  }

  public handleDymamicUrls(priceDetail, pdpPageLink, params) {
    const newProps = this.getPropertyWhenMinMaxSame(priceDetail);
    const urls = this.setDynamicUrls({ priceDetail, pid: priceDetail.productIdentifier, ...params });
    priceDetail['pdpPageLink'] = pdpPageLink;
    return {  ...priceDetail, ...newProps, ...urls }
  }

  private setDynamicUrls({ priceDetail, pid, screenId, intc, pageId, soc = '', rafid = '', afc = '', category = '', app = 'UNSOL' }) {
    const dynamicOfferUrl = {};
    const hashCode = typeof priceDetail === 'undefined' ? "" : priceDetail['hashCode'];
    app = app || 'UNSOL';
    dynamicOfferUrl['apply-now-button'] = this.setParamsToURL(this.mktDynamicOfferService.buildApplyNowUrl(
      screenId,
      intc,
      pageId,
      pid,
      hashCode,
      this.isDefaultOffer(priceDetail.offerName)
    ), `category=${category},intc=${intc},afc=${afc},rafid=${rafid},soc=${soc},app=${app}`, false);
    dynamicOfferUrl['pdpPageLink'] = this.setParamsToURL(priceDetail.pdpPageLink, `category=${category},intc=${intc},afc=${afc},rafid=${rafid},soc=${soc},app=${app}`);
    dynamicOfferUrl['mbol-apply-now-button'] = this.setParamsToURL(this.mktDynamicOfferService.getMbolApplyNowUrl(pid, hashCode), `app=${app}`, false);
    dynamicOfferUrl['terms-link'] = this.setParamsToURL(this.mktDynamicOfferService.getPricingInfoUrl(pid, hashCode), `app=${app}`, false);
    dynamicOfferUrl['hashCode'] = hashCode;
    return dynamicOfferUrl;
  }

  formatData(key, value) {
    switch (key) {
      case 'balconMinimumFee':
      case 'accountLevelBalconMinimumFee':
        value = value * 10;
        break;
      case 'balconFeeRate':
        value = value / 10;
        break;
      case 'accountLevelBalconFeeRate':
        value = value / 10;
        break;
      case 'annualFeeAmount':
        value = (this.isAEMPDPPage || (!!value && value != '0') ? `$${value?.replaceAll('$', '')}` : 'No annual fee');
        break;
      case 'bonusAmount':
      case 'hurdleAmount':
        value = (this.version == "v1") ? this.formatDollar(value) : this.formatCash((value || "").replaceAll(",", ""));
        break;
      case 'balconGoToRateIdentifier':
        value = !!value && value == '0' ? '' : null;
        break;
      default:
        value = value ?? '';
    }
    return value;
  }

  formatDollar(amt: string) {
    amt =
      amt !== undefined ? amt.replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1,') : '';
    return amt;
  }

  formatCash = n => {
    if (n < 1e3) return n;
    if (n >= 1e3 && n < 1e6) return +(n / 1e3).toFixed(1) + "K";
    if (n >= 1e6 && n < 1e9) return +(n / 1e6).toFixed(1) + "M";
    if (n >= 1e9 && n < 1e12) return +(n / 1e9).toFixed(1) + "B";
    if (n >= 1e12) return +(n / 1e12).toFixed(1) + "T";
  };


  public citAAText(renderer2, dynamicData, productIdentifier) {
    if (dynamicData['balconGoToRateIdentifier'] === "0") {
      const contents = document.querySelectorAll('.balcon-' + productIdentifier);
      contents.forEach(item => {
        renderer2.setProperty(
          item,
          'innerHTML',
          ''
        );
      })
    }
    if (dynamicData['flexPlanFeeFlag'] === false) {
      const contents = document.querySelectorAll('.flexflag-' + productIdentifier);
      contents.forEach(item => {
        renderer2.setProperty(
          item,
          'innerHTML',
          ''
        );
      })
    }
    if (dynamicData['balconGoToRateIdentifier'] !== "0") {
      const contents = document.querySelectorAll('.nobalcon-' + productIdentifier);
      contents.forEach(item => {
        renderer2.setProperty(
          item,
          'innerHTML',
          ''
        );
      })
    }
    if (dynamicData['flexPlanFeeFlag'] === true) {
      const contents = document.querySelectorAll('.noflexflag-' + productIdentifier);
      contents.forEach(item => {
        renderer2.setProperty(
          item,
          'innerHTML',
          ''
        );
      })
    }
  }

  public injectDynamicText(elementRef, renderer2, dynamicData, productIdentifier, productType = null) {
    for (const key of Object.keys(dynamicData)) {
      let priceValue = dynamicData[key];
      let tempKey = key + '-' + productIdentifier;
      tempKey = tempKey + (productType ? ('_' + productType) : '');
      if (key.toLowerCase() === 'pid800number') { continue; }
      const formattedPriceValue = this.formatData(key, priceValue);
      if (formattedPriceValue === null) this.removeTextForCIT(renderer2);
      if (key === 'balconGoToRateIdentifier' && formattedPriceValue === null) continue;
      const dynamicVariableElementList = elementRef.nativeElement.querySelectorAll(
        `[data-id="${tempKey}"]`
      );
      for (let i = 0; i < dynamicVariableElementList.length; i++) {
        const dynamicVariableSpanElement = dynamicVariableElementList[i];
        renderer2.setProperty(
          dynamicVariableSpanElement,
          'innerHTML',
          formattedPriceValue
        );
      }
      if (key === 'rewardPromotion') {
        const rewardsObj = !!dynamicData[key] && { ...dynamicData[key], ...dynamicData[key]?.rewardPromotionDetail[0] } || {};
        this.injectDynamicText(elementRef, renderer2, rewardsObj, productIdentifier, productType);
      }
    }
  }

  private removeTextForCIT(renderer2) {
    const contents = document.querySelectorAll('.flipData');
    contents.forEach(item => {
      if (item.getAttribute('data-flip') === 'true') {
        renderer2.setProperty(
          item,
          'innerHTML',
          ''
        );
      }
    })
  }

  public injectDynamicUrls(elementRef, renderer2, urls, pid = null, productType = null) {
    for (const key of Object.keys(urls)) {
      const pidPT = pid + (productType ? ('_' + productType) : '');
      let originalKey = (!!pidPT && pidPT !== 'null' && pidPT !== 'undefined') ? key + '-' + pidPT : key;
      console.log('originalKey - ', originalKey);
      const dynamicVariableElementList = elementRef.nativeElement.querySelectorAll(`[data-id="${originalKey}"]`);
      const dynamicVariableElementList2 = elementRef.nativeElement.querySelectorAll(`[id="${key}"]`);
      const dynamicVariableElementList3 = elementRef.nativeElement.querySelectorAll(`[flowId="${key}"]`);
      const dynamicVariableElementList4 = elementRef.nativeElement.querySelectorAll(`[data-sup-price-id="${pidPT}"]`);
      for (let i = 0; i < dynamicVariableElementList.length; i++) {
        const dynamicVariableSpanElement = dynamicVariableElementList[i];
        renderer2.setProperty(dynamicVariableSpanElement, 'href', urls[key]);
        if (!this.hasAgentInputField() &&
        dynamicVariableSpanElement.getAttribute('data-id')?.includes('applyNowUrl') &&
        dynamicVariableSpanElement.getAttribute('aria-disabled') == 'true') {
          renderer2.removeAttribute(dynamicVariableSpanElement, 'disabled');
          renderer2.setAttribute(dynamicVariableSpanElement, 'aria-disabled', 'false');
          renderer2.removeClass(dynamicVariableSpanElement, 'disabled-link');
        }
      }
      for (let i = 0; i < dynamicVariableElementList2.length; i++) {
        const dynamicVariableSpanElement = dynamicVariableElementList2[i];
        renderer2.setProperty(dynamicVariableSpanElement, 'href', urls[key]);
      }
      for (let i = 0; i < dynamicVariableElementList3.length; i++) {
        const dynamicVariableSpanElement = dynamicVariableElementList3[i];
        renderer2.setProperty(dynamicVariableSpanElement, 'href', urls[key]);
      }
      for (let i = 0; i < dynamicVariableElementList4.length; i++) {
        const dynamicVariableSpanElement = dynamicVariableElementList4[i];
        renderer2.setProperty(dynamicVariableSpanElement, 'href', urls[key]);
      }
    }
  }

  private hasAgentInputField(): boolean {    
    const inputField1 = <any>(this._document.querySelector("tds-family-cta-sticky  .sticky1  .cds-input"));
    const inputField2 = <any>(this._document.querySelector("tds-family-cta-sticky  .sticky2  .cds-input"));
    return !!inputField1 || !!inputField2 || false;
  }

  public loadBundleContent({ isBrand = true, isHP=false, aemPages = {isAEMPage:false, pageName:null, category: null, variation: null}, isMPP = false, isPDP = false, isAddInfo = false, isMicro = false, isDigital = false, isAll = false }): Promise<any> {
    if (isAll) {
      isBrand = isMPP = isPDP = isAddInfo = true;
      isMicro = isDigital = false;
    }
    const bundles = [
      { isAEMBundle: false, condition: isBrand, bundle: CONSTANTS.BRANDING_BUNDLE, options:{} },
      { isAEMBundle: false, condition: isHP, bundle: CONSTANTS.HOME_BUNDLE, options:{} },
      { isAEMBundle: false, condition: isMPP, bundle: CONSTANTS.MULTI_PRODUCT_BUNDLE, options:{} },
      { isAEMBundle: false, condition: isPDP, bundle: CONSTANTS.PRODUCT_DETAIL_BUNDLE, options:{} },
      { isAEMBundle: false, condition: isAddInfo, bundle: CONSTANTS.ADDITIONAL_INFO_BUNDLE, options:{} },
      { isAEMBundle: false, condition: isMicro, bundle: CONSTANTS.MICROSITE_BUNDLE, options:{} },
      { isAEMBundle: false, condition: isDigital, bundle: CONSTANTS.DIGITAL_WALLET_BUNDLE, options:{} },
      { isAEMBundle: true, condition: aemPages.isAEMPage, bundle: (!!aemPages.category && aemPages.category.includes('all-cards')) ? 'family' : aemPages.pageName, options:{} },
    ];

    const promises = bundles
      .filter(({ condition, bundle }) => condition && !this._mktContentStorageService.getByAppId(bundle))
      .map(({ bundle, options, isAEMBundle }) => isAEMBundle ? this._mktAEMService.getPageContent(bundle, aemPages.category, aemPages.variation).toPromise() : this._mktContentService.getStaticBundle(bundle, options).toPromise());

      return Promise.all(promises).then(() => Promise.resolve());
  }

  public getPropertyWhenMinMaxSame(dynamicDataObj) {
    if (!dynamicDataObj) return;
    if (dynamicDataObj.maximumAnnualPercentageRate == dynamicDataObj.minimumAnnualPercentageRate) {
      dynamicDataObj["annualPercentageRateSame"] = dynamicDataObj.minimumAnnualPercentageRate;
      dynamicDataObj["annualPercentageRateSameN"] = '';
    }
    if (dynamicDataObj.balconAnnualPercentageRate == dynamicDataObj.balconMaximumAnnualPercentageRate) {
      dynamicDataObj["balconAnnualPercentageRateSame"] = dynamicDataObj.balconAnnualPercentageRate;
      dynamicDataObj["balconAnnualPercentageRateSameN"] = '';
    }
    return dynamicDataObj;
  }

  public populateDynamicValues(pid: number, elementRef: ElementRef, renderer2: Renderer2, productType = null, app = 'UNSOL') {
    const instance = setInterval(() => {
      const priceDetails = this._transferState.get(PRICE_DETAILS_KEY, []);
      if (priceDetails.length === 0) return;
      clearInterval(instance);
      if (!!pid) {
        const dynamicPrice = priceDetails.filter(({ productIdentifier, productType: pt }) => {
          if (productType) {
            return pid == productIdentifier && pt === productType;
          }
          return pid == productIdentifier;
        })[0];
        if (!!dynamicPrice) this.setPriceForEachCard(dynamicPrice, elementRef, renderer2, app);
      } else {
        priceDetails.forEach(async dynamicPrice => await this.setPriceForEachCard(dynamicPrice, elementRef, renderer2, app))
      }
    }, 500);
  }

  injectDynamicElAttr = (elementRef: ElementRef, renderer2: Renderer2, selector: string, attributes: UpdateElement = null, events: Array<ElementEvents> = null, sourceObj?: any) => {
    let dynamicVariableElementList = this.getDynamicElements(elementRef, selector);
    for (const dynamicVariableElement of dynamicVariableElementList) {
      if (!attributes?.id && !dynamicVariableElement?.id) {
        attributes['id'] = '';
      }
      if (attributes) {
        this.setDynamicElAttr(dynamicVariableElement, renderer2, selector, attributes);
      }
      if (events && sourceObj) {
        this.setDynamicElEvents(dynamicVariableElement, renderer2, events, sourceObj);
      }
    }
  }

  getDynamicElements = (elementRef: ElementRef, selector: string) => {
    let dynamicVariableElementList = elementRef.nativeElement.querySelectorAll(`${selector}`);
    if (isPlatformBrowser(this.platform_id) && dynamicVariableElementList?.length === 0) {
      dynamicVariableElementList = document.querySelectorAll(`${selector}`);
    }
    return dynamicVariableElementList;
  }

  private setDynamicElAttr = (dynamicVariableElement: any, renderer2: Renderer2, selector: string, attributes: UpdateElement = null) => {
    try {
      for (let [key, value] of Object.entries(attributes)) {
        if (key.trim().toLowerCase() === 'class') {
          if (value.includes(';')) {
            value.split(';').forEach((t: string) => {
              renderer2.addClass(dynamicVariableElement, t.trim());
            });
          } else {
            renderer2.addClass(dynamicVariableElement, value.trim());
          }
        }
        else if (key.trim().toLowerCase() === 'style') {
          value.split(';').forEach(t => {
            const style = t.split(':');
            if (style) {
              renderer2.setStyle(dynamicVariableElement, style[0].trim(), style[1].trim());
            }
          });
        }
        else {
          if (key === 'id' && !value) {
            const idValue = this.getAttributeId(selector, dynamicVariableElement);
            renderer2.setAttribute(dynamicVariableElement, key.trim(), idValue.trim());
          } else {
            renderer2.setAttribute(dynamicVariableElement, key.trim(), (value || "").trim());
          }
        }
      }
    } catch (error) {

    }
  }

  setDynamicElEvents = (dynamicVariableElement: any, renderer2: Renderer2, events: Array<ElementEvents> = null, sourceObj?: any) => {
    events.forEach((e: any) => {
      const el = this.eventListeners.find(t => t['el']['id'] === dynamicVariableElement?.id && t['event'] === e.event && t['cb']['name'] === e.callback.name);
      if (!el) {
        const cb = e.callback.bind(sourceObj);
        this.eventListeners.push({ el: dynamicVariableElement, event: e.event, cb: e.callback });
        renderer2.listen(dynamicVariableElement, e.event, event => cb(event, ...e.args));
      }
    });
  }

  private setPriceForEachCard(dynamicPrice: any, elementRef: ElementRef<any>, renderer2: Renderer2, app = 'UNSOL') {
    let dynamicUrls = {
      'applyNowUrl': dynamicPrice.isMbol ? dynamicPrice['mbol-apply-now-button'] : dynamicPrice['apply-now-button'],
      'mbolApplyNowUrl': dynamicPrice['mbol-apply-now-button'],
      'termsUrl': dynamicPrice['terms-link'],
    };
    (!!app && app !== 'UNSOL') && Object.keys(dynamicUrls).forEach((v) => {
      dynamicUrls[v] = dynamicUrls[v].replace("=UNSOL", "=" + app);
    });
    const dynamicContent = this.setupDynamicContent(dynamicPrice);
    this.injectDynamicText(elementRef, renderer2, dynamicContent, dynamicPrice.productIdentifier, dynamicPrice.productType);
    this.injectDynamicText(elementRef, renderer2, dynamicPrice, dynamicPrice.productIdentifier, dynamicPrice.productType);
    this.injectDynamicUrls(elementRef, renderer2, dynamicUrls, dynamicPrice.productIdentifier, dynamicPrice.productType);
  }

  private getAttributeId(selector: string, element: any) {
    if (element && !element?.id) {
      let ctime = new Date().getTime();
      if (isPlatformBrowser(this.platform_id)) {
        const crypto = window.crypto;
        const rnArr = new Uint32Array(1);
        crypto.getRandomValues(rnArr);
        ctime = ctime + rnArr[0];
      }
      return (selector && selector?.replace(/[^a-zA-Z0-9-]/g, '')) + ctime;
    }
    return element?.id;
  }

  public getCardsWithRatings() {
    return this._transferState.get(CARDS_WITH_RATINGS, null);
  }

  public setParamsToURL = (url, value, hostReplace = true) => {
    if (!this.isBrowser) return url;
    const newUrl = new URL(url, origin);
    if (hostReplace) {
      newUrl.host = window.location.host;
      newUrl.protocol = window.location.protocol;
    }
    const params = value.split(",");
    params.forEach(async value => {
      let keyValues = value.split("=");
      keyValues[1] != '' && newUrl.searchParams.set(keyValues[0], keyValues[1]);
    })
    return newUrl.toString();
  };

  public isRAFJourneyDisable(): boolean {
    if (!this.isBrowser) return false;
    const bannerConfigContent = this._mktContentService.get('Branding', 'copy', 'BannerConfig', undefined);
    const raf = JSON.parse(bannerConfigContent.raf || '{}');
    const start = new Date(raf.startDate); // startDate = MM/DD/YYYY
    const end = new Date(raf.endDate); // endDate = MM/DD/YYYY
    let isExpired = true;
    const currentDate = new Date(`${new Date().getMonth() + 1}/${new Date().getDate()}/${new Date().getFullYear()}`);
    if (currentDate >= start && currentDate <= end) {
      isExpired = false;
    }
    return (!raf.isRAF || isExpired);
  }

  public getFeatureContent(featureKey = "") {
    let featuresData = {};
    let feature = featureKey.split("-");
    if (!featuresData[feature[0]]) {
      featuresData[feature[0]] = this._mktContentService.get('Multi_Product_Page', 'copy', feature[0], undefined);
    }
    return JSON.parse(featuresData[feature[0]]?.[feature[1]]);
  }

  setupDynamicContent({ bullets = [] }) {
    let content = {};
    let featureData = this._mktContentService.get('Product_Detail_Pages', 'copy', "ITSSBullets", undefined);
    bullets.forEach(featureKey => {
      content[featureKey] = featureData[featureKey];
      return content;
    });
    return content;
  }

  setRibbonShowHide(pidList: string[], pid: string) {
    return pidList.indexOf(pid) > -1 ? "N" : "Y";
  }

  sanitizeObject(obj) {
    return Object.entries(obj).reduce((acc, [key, value]) => {
      if (value !== null && value !== undefined) {
        acc[key] = typeof value === 'object' ? this.sanitizeObject(value) : value;
      }
      return acc;
    }, {} as any);
  }

  // Delete the cookies created for Redesign page navigation.
  // Otherwise it will cause issue when adding new card from compare page for legacy pages
  deleteRedesignPageCookie() {
    this._cookieService.deleteCookie('vacReDesignexplore', '/credit-cards', window?.location?.hostname);
    this._cookieService.deleteCookie('vacReDesignvac', '/credit-cards', window?.location?.hostname);
    this._cookieService.deleteCookie('vacReDesignmpp', '/credit-cards', window?.location?.hostname);
  }

  private checkMobileorDesktop() {
    const bPoint992x = '(max-width: 991px)';
    this.breakpointObserver
      // pass values from constants.ts
      .observe([bPoint992x])
      .subscribe(x => {
        // check if defined breakpoints match the screen size
        this.isMobile = x.breakpoints[bPoint992x];
      });
  }

  setBannerTaggingVendorData = () =>{
    this.mktDynamicOfferService.setTaggingStaticIcms({TEXT:JSON.stringify({
      "OS": {
        "OSMetaData": "[^-|{:},.?\t\n\r []\"A-Za-z0-9_~=/&^]",
        "blackListKeywords": [
          "script",
          "embed",
          "object"
        ],
        "payloadSize": 16384,
        "whiteListVariables": [
          "rf_placement1",
          "rf_placement2",
          "rf_placement3",
          "rf_placement4",
          "rf_placement5",
          "rf_placement6",
          "rf_placement7",
          "rf_placement8",
          "pid",
          "contentID",
          "moduletype",
          "decisionType",
          "clickURL",
          "scenarioID",
          "creativeGroupID",
          "creativename",
          "rf_placements",
          "rf_bannerService",
          "templateID"
        ]
      },
      "RF": {
        "RFMetaData": "[^-|{:},.?\t\n\r []\"A-Za-z0-9_~=/&^]",
        "blackListKeywords": [
          "script",
          "embed",
          "object"
        ],
        "payloadSize": 16384,
        "whiteListVariables": [
          "rf_placement1",
          "rf_placement2",
          "rf_placement3",
          "rf_placement4",
          "rf_placement5",
          "rf_placement6",
          "rf_placement7",
          "rf_placement8",
          "pid",
          "contentID",
          "moduletype",
          "decisionType",
          "clickURL",
          "scenarioID",
          "creativeGroupID",
          "creativename",
          "rf_placements",
          "rf_bannerService",
          "templateID"
        ]
      },
      "acxiom_gpol": {
        "AOSMetaData": "[^-|{:},.\t\n\r []\"A-Za-z0-9_]",
        "AOSSuccessRCode": "I000",
        "blackListKeywords": [
          "script",
          "embed",
          "object"
        ],
        "payloadSize": 16384,
        "whiteListVariables": [
          "GPOLRs",
          "rCode",
          "rMsg",
          "ofrlst",
          "attributes",
          "mem",
          "name",
          "value",
          "type",
          "rank",
          "mcode",
          "scode",
          "brd",
          "pid",
          "uc",
          "csec",
          "fr",
          "lvl",
          "c",
          "pl",
          "spl",
          "m",
          "axDP",
          "axDS",
          "axIPO",
          "axCan",
          "src",
          "ecm",
          "rvw",
          "cmp",
          "brk",
          "ret",
          "bk",
          "pgid",
          "uid",
          "pd",
          "subc",
          "spd",
          "rvd",
          "tad",
          "cat",
          "ep",
          "pr",
          "mr",
          "bpr",
          "cmv",
          "rpr"
        ]
      },
      "liveRamp": {
        "blackListKeywords": [
          "script",
          "embed",
          "object"
        ],
        "whiteListVariables": [
          "idl"
        ]
      }
    }),"offerPlacement":"[1,2,3,4]", "isTaggingFallback": false}) ;
  }

  public getProspectIDFromApplyNowURL(applyNowURL: string) {
    if (applyNowURL) {
      const splits = applyNowURL.split('&')
      let prospectID = ''
      splits.forEach(split => {
        if (split.includes('ProspectID')) {
          prospectID = split.split('=')[1]
        }
      })
      return prospectID
    }
    return ''
  }

    public buildAEMImgUrl = (aemImagePrefix: string, path: string): string => {
        if (!path) return null;
        // Remove the prefix if it exists
        if( path.includes('/content/dam/cfs/uspb/usmkt/cards/en/static/images/')) {
            path = path.replace('/content/dam/cfs/uspb/usmkt/cards/en/static/images/', '');
        }
        return `${aemImagePrefix}/${path}`;
    }

   public setPDPLink(params?: any): void {
      let links = this._document.querySelectorAll<HTMLAnchorElement>('a[data-id="pdpPageLink"]');
      if (!links) return;
      if (!params && this.flowParams) params = this.flowParams;
      const pdpParams = ['category', 'intc', 'afc', 'flowId','soc', 'rafid', 'PO', 'OC', 'app', 'targetid','dclid', 'gclid', 'dclid', 'gclsrc', 'ProspectID'];
      links.forEach((link) => {
          if (link?.href) {
              let url = new URL(link.href);
              pdpParams?.forEach((pdpParam: string) => {
                if(Object?.keys(params)?.includes(pdpParam) && params?.[pdpParam]) {
                  // If the key already exists, update it; otherwise, append it
                  url.searchParams.set(pdpParam, params?.[pdpParam] || '');
                }
              });
              link.href = url.toString();
          }
      });
  }

    public isMbolPreLoginFlow = (flowId, isMbolFlagPreLogin = false): boolean => (flowId === MBOL_PRE_LOGIN && isMbolFlagPreLogin);

    public isMbolPostLoginFlow = (flowId, isMbolFlagPostLogin = false): boolean => (flowId === MBOL_POST_LOGIN && isMbolFlagPostLogin);

    public isMbolWorkFlow = (flowId): boolean => (!!flowId && [MBOL_PRE_LOGIN, MBOL_POST_LOGIN].includes(flowId));
}

export const loadScript = (document, url, selector:string, priority=PRIORITY.ASYNC) => {
  const scriptExist = document.querySelector(`#${selector}`);
  if (scriptExist) {
    return;
  };
  // Create the script
  const script = document.createElement('script');
  script.src = url;
  script.id = selector;
  script[priority] = true;
  script.nonce = "CSP_NONCE_PLACEHOLDER";
  document.getElementsByTagName('head')[0].appendChild(script);
}
